import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 35 35"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M21.476 18.563h-2.181V26h-2.91v-7.437H14v-3.055h2.386V13.15c0-2.656 1.396-4.15 3.52-4.15C20.924 9 22 9.232 22 9.232v2.624h-1.193c-1.163 0-1.512.796-1.512 1.66v1.992h2.589z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }